// imports the tiptap extension from node_modules
import Color from '@tiptap/extension-color';
export default (options) => {
  return Color.extend({});
};
